export const moduleId = 'subject-message';

export const state = {
    subject: null
}
export const mutations = {
    setSubject(state, data) {
        state.subject = data
    }
}
export const actions = {}




// WEBPACK FOOTER //
// ./src/store/modules/global-data-maintain/subject-message/index.js